// import { Directionality } from "@angular/cdk/bidi";
import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { NzSubMenuTitleComponent } from "ng-zorro-antd/menu";
import { UiMenuModeType } from "../../menu.models";

@Component({
  selector: "[ui-submenu-title]",
  exportAs: "uiSubmenuTitle",
  templateUrl: "./submenu-title.component.html",
  host: {
    "[class.ant-dropdown-menu-submenu-title]": "isMenuInsideDropDown",
    "[class.ant-menu-submenu-title]": "!isMenuInsideDropDown",
    "[style.paddingLeft.px]": `dir === 'rtl' ? null : paddingLeft `,
    "[style.paddingRight.px]": `dir === 'rtl' ? paddingLeft : null`,
  },
})
export class UiSubmenuTitleComponent extends NzSubMenuTitleComponent {
  @Input("uiTitleIcon") public nzIcon: string | null = null;
  @Input("uiTitle") public nzTitle: string | TemplateRef<void> | null = null;
  @Input("uiTitleIsInsideDropDown") public isMenuInsideDropDown = false;
  @Input("uiTitleDisabled") public nzDisabled = false;
  @Input("uiTitlePaddingLeft") public paddingLeft: number | null = null;
  @Input("uiTitleMode") public mode: UiMenuModeType = "vertical";
  @Output("uiTitleToggle") public readonly toggleSubMenu = new EventEmitter();
  @Output("uiTitleMouseState") public readonly subMenuMouseState = new EventEmitter<boolean>();
}
